import { SnContentType } from './content-type';

export interface IHasContentType {
  readonly contentType: SnContentType;
}
